module.exports = __webpack_public_path__ + "img/xiaobianzi.c14b9cee.png";